import React from 'react'
import { AvatarCompat } from 'components/shared/AvatarCompat'
import Icon from 'svg-inline-react'

import './style.styl'
import moment from 'moment'
import GEO_PIN from '!svg-inline?removeTags=true!images/svg/location-pin.svg'
import Social from "../Social"

const FOLLOW_ICON_SRC = require('images/live/enduser-follow-live.svg')
const FOLLOWING_ICON_SRC = require('images/live/enduser-following-live.svg')

const ContactHeader = ({ user, hasFollowing, userStatus, following, updateFollowing }) => {

  const geo = _.get(userStatus, 'geo')
  let location = ' - '
  if (!!geo) {
    location = _.compact([
      geo.city,
      geo.subdivision,
      geo.country,
    ]).join(', ')
  }

  const { attributes, name } = user
  const linkedin = user.getIn(['attributes', 'linkedin_handle'])
  const twitter = user.getIn(['attributes', 'twitter_handle'])

  const userAvatar = <AvatarCompat user={user} type="user" size="small"/>

  const followingSRC = following ? FOLLOWING_ICON_SRC : FOLLOW_ICON_SRC
  const followingCopy = following ? 'Following' : 'Follow'
  const followingLinkContent = () => <span><img className="contact-info-location-icon" src={followingSRC}/>{followingCopy} </span>
  const followingLink = <span onClick={updateFollowing}>{followingLinkContent()}</span>


  return (
    <div>
      <div className="company-info-header">
        <div className="contact-info-header-left">
          {userAvatar}
        </div>
        <div className="company-info-header-right">
          <div className="contact-info-title">{name}</div>
          {attributes.employment_title && <div>{attributes.employment_title}</div>}
          <div className="contact-info-location"><Icon
            src={GEO_PIN} /> {moment(userStatus.lastUpdateAt).format('hh:mmA')} {location}</div>
          <div className="contact-info-social">
            {!!twitter && <Social type="twitter" handle={twitter} className="contact-info-social-icon"/>}
            {!!linkedin && <Social type="linkedin" handle={linkedin} className="contact-info-social-icon"/>}
            {hasFollowing && followingLink}
          </div>
        </div>
      </div>

    </div>)
}


export default ContactHeader



// WEBPACK FOOTER //
// ./src/scripts/components/shared/ContactRecordLite/ContactHeader/index.js